var AdditionalInputValueChangingButtons;
(function (AdditionalInputValueChangingButtons) {
    AdditionalInputValueChangingButtons["typing"] = "typing";
    AdditionalInputValueChangingButtons["plus"] = "plus";
    AdditionalInputValueChangingButtons["minus"] = "minus";
    AdditionalInputValueChangingButtons["min"] = "min";
    AdditionalInputValueChangingButtons["max"] = "max";
    AdditionalInputValueChangingButtons["allIn"] = "allIn";
    AdditionalInputValueChangingButtons["multiply"] = "multiply";
    AdditionalInputValueChangingButtons["divide"] = "divide";
    AdditionalInputValueChangingButtons["inputBlur"] = "inputBlur";
})(AdditionalInputValueChangingButtons || (AdditionalInputValueChangingButtons = {}));
var InputTypesForChanging;
(function (InputTypesForChanging) {
    InputTypesForChanging["BetInput"] = "BetInput";
    InputTypesForChanging["AutoCashOutInput"] = "AutoCashOutInput";
    InputTypesForChanging["Other"] = "Other";
})(InputTypesForChanging || (InputTypesForChanging = {}));

export { AdditionalInputValueChangingButtons, InputTypesForChanging };
